import { DRAGGABLE_RECORDS } from '@common/constants/custom/statuses';
import { Dictionary } from '@common/types';

export const isRecordDroppable = (dictionary: Dictionary = Dictionary.Empty) => DRAGGABLE_RECORDS.includes(dictionary);
